import React from "react";
import { TIFFViewer } from "react-tiff";
import "./TiffViewer.css";

const TIFFFileViewer = ({ tiff = "" }) => {
  return (
    <TIFFViewer tiff={tiff} lang="en" paginate="bottom" buttonColor="#141414" />
  );
};

export default TIFFFileViewer;
